import React from "react";
import { useTranslation } from "react-i18next";

// Styles
import styles from "./streak.module.css";

// Utils

// Assets
import FireIcon from "./assets/fire.png";

// Types
interface StreakProps {
  streak: number;
  type: 'quiz' | 'badge' | 'show';
}

const Streak: React.FC<StreakProps> = ({ streak, type }) => {
  // Hooks
  const { t } = useTranslation();

  // Style
  let mainContainerStyle = styles.container;
  switch (type) {
    case 'quiz':
      mainContainerStyle += ` ${styles.quiz}`;
      break;
    case 'badge':
      mainContainerStyle += ` ${styles.badge}`;
      break;
    case 'show':
      mainContainerStyle += ` ${styles.show}`;
      break;
    default:
      break;
  }

  // Style
  const renderText = () => {
    switch (type) {
      case 'quiz':
        return (
          <p className='text-md text-amber-600'>
            {t('progress.days_streak', { count: streak })}
          </p>
        )
      case 'badge':
        return (
          <p className='text-md text-amber-600'>
            {streak}
          </p>
        )
      case 'show':
      default:
        return (
          <>
            <h3 className='text-md text-amber-600'>
              {t('progress.streak_count', { count: streak })}
            </h3>

            <p className='text-sm text-gray-500 dark:text-gray-400'>
              {t('progress.daily_streak')}
            </p>
          </>
        )
    }
  }

  return (
    <div className={`${mainContainerStyle}`}>
      <div className={styles.iconContainer}>
        <img src={FireIcon} alt='Fire' className='w-8 h-8' />
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.title}>
          {renderText()}
        </div>
      </div>
    </div>
  )
}

export default Streak;
